import { defineMessages } from 'react-intl'

const scope = 'procurify.platform.globalCommand.ConversationFooter'

export default defineMessages({
  inputPlaceholder: {
    id: `${scope}.inputPlaceholder`,
    defaultMessage: 'Ask a follow-up or reply...',
  },
  inputAriaLabel: {
    id: `${scope}.inputAriaLabel`,
    defaultMessage: 'Conversation input',
  },
  submitAriaLabel: {
    id: `${scope}.submitAriaLabel`,
    defaultMessage: 'Send message',
  },
  disclaimer: {
    id: `${scope}.disclaimer`,
    defaultMessage:
      'Procurify AI can make mistakes. Review items before submitting.',
  },
})
